import React from 'react';
import { DollarSign, Clock, Building, Briefcase } from 'lucide-react';
import { investmentRequired, marketingImages } from '../../data/mock';

const InvestmentRequired = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {investmentRequired.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Minimal startup costs compared to traditional business ventures
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Investment Details */}
          <div>
            {/* Startup Costs */}
            <div className="bg-white rounded-2xl p-8 shadow-lg mb-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">To Start All Three Income Streams:</h3>
              <div className="space-y-4">
                {investmentRequired.startup.map((item, idx) => (
                  <div key={idx} className="flex justify-between items-center py-3 border-b border-gray-100 last:border-0">
                    <span className="text-gray-700">{item.item}</span>
                    <span className="font-bold text-teal-600">
                      {item.cost} <span className="text-gray-500 font-normal text-sm">{item.note}</span>
                    </span>
                  </div>
                ))}
              </div>
              
              <div className="mt-6 pt-6 border-t-2 border-teal-500">
                <div className="flex justify-between items-center mb-2">
                  <span className="font-semibold text-gray-900">Total minimum:</span>
                  <span className="text-2xl font-bold text-teal-600">{investmentRequired.totalMin}</span>
                </div>
                <p className="text-sm text-gray-500 text-right">{investmentRequired.totalMinNote}</p>
              </div>
            </div>

            {/* Comparison */}
            <div className="bg-gray-900 rounded-2xl p-8 text-white">
              <h3 className="text-xl font-bold mb-6">Compare This To:</h3>
              <div className="space-y-4">
                {investmentRequired.comparison.map((item, idx) => (
                  <div key={idx} className="flex justify-between items-center">
                    <span className="text-gray-300">{item.option}</span>
                    <span className="font-semibold text-red-400">{item.cost}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* ROI Image */}
          <div className="flex justify-center">
            <img 
              src={marketingImages.roi} 
              alt="Return on Investment"
              className="w-full max-w-md rounded-2xl shadow-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentRequired;
